import { getProblemMessage } from "../../lib/problemMessage";

import { isPatientAuthApiError } from "./patientAuthenticationApi";
import { FALLBACK_ERROR_MESSAGE } from "./patientAuthMessages";

/** API の problem+json の detail をそのまま出す（無ければ決まった文言）。 */
export const errorMessageOf = (error: unknown): string =>
  getProblemMessage(error, FALLBACK_ERROR_MESSAGE);

export const errorCodeOf = (error: unknown): string | undefined =>
  isPatientAuthApiError(error) ? error.code : undefined;

export const isSessionExpired = (error: unknown): boolean =>
  errorCodeOf(error) === "PATIENT_AUTH_SESSION_EXPIRED";
